import React, { useState, useContext } from "react";
import { FormContainer } from "../style";
import ImagePreview from "./components/ImagePreview";
import { Screens, Forms } from "../constants";
import { hexToRgba } from "src/utils/colors";
import { useFormData } from "./useFormData";
import { UserContext } from "src/scenes/App/UserContext";
import { isArticleEmpty } from "../utils";

const MobilePreview = (props) => {
    const currentUser = useContext(UserContext);
    const { formData } = useFormData();

    // Initialize counters for current form and screen
    const [counters, setCounters] = useState({
        currentForm: Forms.INITIAL,
        currentScreen: Screens.MAIN,
    });

    const getSlidesForScreen = () => {
        const slides = [
            Screens.MAIN,
            Screens.QUOTES,
        ];
        if ((!isArticleEmpty(formData.article) || formData.objectImage.article)) {
            slides.push(Screens.ARTICLES);
        }
        return slides;
    };

    const screenIds = getSlidesForScreen();

    const buildColourPalette = () => {
        const { primaryColor, secondaryColor, backgroundColor } = props.settingsPreview;
        return {
            primaryColor: hexToRgba(primaryColor),
            secondaryColor: hexToRgba(secondaryColor),
            backgroundColor: hexToRgba(backgroundColor),
        };
    };

    const rightScreen = () => {
        setCounters((prev) => {
            const lastIndex = screenIds.length - 1;
            const nextScreen = prev.currentScreen >= lastIndex ? 0 : prev.currentScreen + 1;
            return { ...prev, currentScreen: nextScreen };
        });
    };

    const leftScreen = () => {
        setCounters((prev) => {
            const lastIndex = screenIds.length - 1;
            const prevScreen = prev.currentScreen <= 0 ? lastIndex : prev.currentScreen - 1;
            return { ...prev, currentScreen: prevScreen };
        });
    };

    return (
        <FormContainer maxWidth="566px" height="829px" overflow="hidden" padding="1rem">
            <ImagePreview
                companyName="Test"
                logoTopOffset={45}
                phoneFrameTopOffset={30}
                currentScreen={counters.currentScreen}
                currentForm={counters.currentForm}
                screenIds={screenIds}
                leftScreen={leftScreen}
                rightScreen={rightScreen}
                colourPalette={buildColourPalette()}
                assetLogoUrl={currentUser.companyLogoUrl}
                formData={formData}
            />
        </FormContainer>
    );
};

export default MobilePreview;
